module.exports = __webpack_public_path__ + "static/media/wrestling-long.cc20b191.mp4";